const DEFAULT_APP_BASE_PATH = '/rapoarte';
const DEFAULT_API_BASE_URL = 'https://rapoarte.kalopsia.pro';
const CARTOFISSERIE_API_BASE_URL = 'https://cartofisserie.kalopsia.pro';
const SAME_ORIGIN_API_HOSTNAMES = new Set([
  'demo.kalopsia.pro',
  'staging.kalopsia.pro',
]);

function normalizeHostname(value) {
  return String(value || '').trim().toLowerCase().replace(/\.$/, '');
}

export function normalizeAppBasePath(value = DEFAULT_APP_BASE_PATH) {
  const normalized = String(value || '').trim();
  if (
    !normalized.startsWith('/')
    || normalized.includes('\\')
    || normalized.includes('?')
    || normalized.includes('#')
    || normalized.includes('://')
    || normalized.split('/').includes('..')
  ) {
    throw new Error('REACT_APP_BASE_PATH must be an absolute URL path.');
  }

  const withoutTrailingSlash = normalized.replace(/\/+$/, '');
  return withoutTrailingSlash || '/';
}

export function normalizeApiBaseUrl(value = DEFAULT_API_BASE_URL) {
  const normalized = String(value || '').trim().replace(/\/+$/, '');
  let parsed;
  try {
    parsed = new URL(normalized);
  } catch (_error) {
    throw new Error('REACT_APP_API_URL must be an absolute HTTP(S) URL.');
  }
  if (
    !['http:', 'https:'].includes(parsed.protocol)
    || parsed.username
    || parsed.password
    || parsed.search
    || parsed.hash
  ) {
    throw new Error('REACT_APP_API_URL must be an absolute HTTP(S) URL without credentials, query, or fragment.');
  }
  return normalized;
}

export function resolveApiBaseUrl(hostname, origin) {
  const normalizedHostname = normalizeHostname(hostname);

  if (SAME_ORIGIN_API_HOSTNAMES.has(normalizedHostname)) {
    return normalizeApiBaseUrl(origin);
  }

  if (
    normalizedHostname === 'cartofisserie.kalopsia.pro'
    || normalizedHostname.endsWith('.cartofisserie.ro')
  ) {
    return CARTOFISSERIE_API_BASE_URL;
  }

  return DEFAULT_API_BASE_URL;
}

export function appBaseUrl(origin, basePath) {
  const normalizedOrigin = normalizeApiBaseUrl(origin);
  const normalizedPath = normalizeAppBasePath(basePath);
  return normalizedPath === '/' ? normalizedOrigin : `${normalizedOrigin}${normalizedPath}`;
}

export const APP_BASE_PATH = normalizeAppBasePath(
  process.env.REACT_APP_BASE_PATH || DEFAULT_APP_BASE_PATH,
);

const browserOrigin = (
  typeof window !== 'undefined'
  && window.location
  && /^https?:$/.test(window.location.protocol)
)
  ? window.location.origin
  : DEFAULT_API_BASE_URL;

const browserHostname = (
  typeof window !== 'undefined'
  && window.location
)
  ? window.location.hostname
  : '';

export const API_BASE_URL = normalizeApiBaseUrl(
  process.env.REACT_APP_API_URL
  || resolveApiBaseUrl(browserHostname, browserOrigin),
);

export const APP_BASE_URL = appBaseUrl(browserOrigin, APP_BASE_PATH);
